import React from 'react';
import PropTypes from 'prop-types';

import './vertical-action-panel.scss';

export function VerticalActionPanel({ children }) {
  return <div className="vertical-action-panel d-flex flex-column align-items-start pt-2">{children}</div>;
}

VerticalActionPanel.propTypes = {
  children: PropTypes.node.isRequired,
};
